module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DefaultBaseInput', {
    attrs: {
      "error": _vm.error,
      "required": _vm.required
    }
  }, [_c('template', {
    slot: "label"
  }, [(_vm.validator === _vm.FORM_VALIDATORS.color) ? _c('span', {
    staticClass: "color-circle",
    style: ({
      backgroundColor: _vm.value
    })
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.label) + "\n    ")]), _vm._v(" "), _c('template', {
    slot: "input"
  }, [_c('div', {
    staticClass: "row m-0 input-div",
    class: _vm.readonly || _vm.disabled ? 'disabled' : ''
  }, [_c('div', {
    staticClass: "col"
  }, [_c('textarea', {
    attrs: {
      "minlength": _vm.minLength || false,
      "maxlength": _vm.maxLength || false,
      "rows": parseInt(_vm.counter) < 25 ? 2 : 2 + parseInt(_vm.counter) / 25,
      "disabled": _vm.disabled,
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "blur": _vm.blurListener,
      "input": _vm.inputListener
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-auto pl-0"
  }, [(_vm.counter) ? _c('span', {
    staticClass: "counter",
    class: {
      counter__full: _vm.counterError
    }
  }, [_vm._v(_vm._s(_vm.counter))]) : _vm._e()])])])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-507e1a07","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/Form/DefaultTextareaInputBloc.vue
// module id = 3179
// module chunks = 0